import React, { useState, useEffect } from 'react';
import { View, Text, StyleSheet, useWindowDimensions, ActivityIndicator } from 'react-native';
import { useIsFocused } from '@react-navigation/native';
import moment from 'moment';
import ajax from '../../helpers/ajaxHelper';
import Urls from '../../services/Urls';
import { navigate } from '../../navigation/RootNavigation';
import MediaComponent from './mediacomponent';
import MediaVideoHub from './mediaVideoHub';

const MediaNewsHub = ({ searchQuery = '' }) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const focus = useIsFocused();
  const { width } = useWindowDimensions();
  const isMobile = width <= 767;

  useEffect(() => {
    getPosts();
  }, [focus]);

  const getPosts = () => {
    setLoading(true);
    ajax
      .get(Urls.GET_POST + 'NEWS')
      .then(({ data }) => {
        if (data.status) {
          const mData = data?.data?.mediahub || data?.payload;
          if (mData && mData?.length) {
            setPosts(mData);
          }
        }
      })
      .catch((error) => console.log('error fetching news posts', error))
      .finally(() => setLoading(false));
  };

  const filteredPosts = posts.filter((item) => {
    if (!searchQuery) return true;
    const q = searchQuery.toLowerCase();
    const title = (item.title || '').toLowerCase();
    const desc = (item.description || '').toLowerCase();
    return title.includes(q) || desc.includes(q);
  });

  return (
    <View style={styles.container}>
      {loading ? (
        <View style={styles.loaderWrap}>
          <ActivityIndicator size="large" color="#6C2BD9" />
        </View>
      ) : filteredPosts && filteredPosts.length > 0 ? (
        <View style={[styles.gridWrap, isMobile && styles.gridWrapMobile]}>
          {filteredPosts.map((data, index) => {
            const formattedDate = data.createdAt
              ? moment(data.createdAt).format('MMM DD, YYYY')
              : 'Industry News';
            return (
              <View
                key={`news-${index}`}
                style={[
                  styles.cardCol,
                  { width: isMobile ? '100%' : width <= 960 ? '48.5%' : '32%' },
                ]}
              >
                <MediaComponent
                  coverImage={data.cover_image || data.file || data.image}
                  title={data.title}
                  description={data.description}
                  date={formattedDate}
                  category="Property News"
                  isMobile={isMobile}
                  onPress={() => {
                    navigate('LandlordMediaDetails', {
                      data: data.id,
                    });
                  }}
                />
              </View>
            );
          })}
        </View>
      ) : (
        <View style={styles.emptyWrap}>
          <Text style={styles.emptyText}>No news articles found</Text>
        </View>
      )}

      {/* Embedded Video Section */}
      <MediaVideoHub />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
  },
  loaderWrap: {
    paddingVertical: 40,
    alignItems: 'center',
  },
  gridWrap: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 16,
    width: '100%',
  },
  gridWrapMobile: {
    gap: 12,
  },
  cardCol: {
    marginBottom: 4,
  },
  emptyWrap: {
    paddingVertical: 40,
    alignItems: 'center',
  },
  emptyText: {
    fontSize: 14,
    color: '#9CA3AF',
  },
});

export default MediaNewsHub;
